import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import compassLogoPath from '../../../img/compassBadge-white.svg';
import intransfer from '@/js/intransfer';

class NavBar extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showName: props.showName,
      startDate: props.startDate,
      endDate: props.endDate,
      meeting_id: props.meeting_id
    };
  }

  render () {
    let compassLogo;
    if (this.props.loggedIn) {
      compassLogo = (
        <a href="#" className='navbar-brand viewMeeting' onClick={intransfer.compass.toViewMeetings}>
          <span className='compassLogo d-inline-block align-top pe-2'>
            <img  src={compassLogoPath} width='44' height='44'/>
          </span>
          <span className='allMeetings d-inline-block align-top small'>All<br />Meetings</span>
        </a>
      );
    } else {
      compassLogo = (
        <div className='navbar-brand'>
          <span className='d-inline-block align-top pe-2'>
              <img src={compassLogoPath} width='44' height='44'/>
          </span>
        </div>
      );
    }

    let showNameAndDates;
    if (this.state.meeting_id) {
      showNameAndDates = (
        <ul className='navbar-nav'>
          <li className='nav-item'>
            <a href="#" className='nav-link editMeeting text-white' onClick={() => { intransfer.compass.toEditMeeting(this.state.meeting_id); }}>
              <span>
                <h2>
                  <div className='h4'>{this.state.showName}</div>
                  <div className='h6'>{moment.utc(this.state.startDate).format('DD MMM')} &ndash; {moment.utc(this.state.endDate).format('DD MMM, YYYY')}</div>
                </h2>
              </span>
            </a>
          </li>
        </ul>
      );
    } else {
      showNameAndDates = null;
    }

    return (
      <nav className='NavBar navbar navbar-expand-sm navbar-dark bg-primary mb-3'>
        {compassLogo}
        {showNameAndDates}
      </nav>
    );
  }
}


NavBar.propTypes = {
  showName: PropTypes.string,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  meeting_id: PropTypes.number,
  meeting_hotel_id: PropTypes.number,
  loggedIn: PropTypes.bool.isRequired
};

export default NavBar;
